import baseAPI from '@/http'

const router = 'api/municipios'

export const municipioAPI = {
    create: (ator) => baseAPI.post(`${router}/criar-municipios`, ator),
    update: (ator) => baseAPI.put(`${router}/atualizar-municipios`, ator),
    delete: (id) => baseAPI.delete(`${router}/obter-municipios/${id}`),
    list: () => baseAPI.get(`${router}/obter-municipios`),
    find: (id) => baseAPI.get(`${router}/obter-municipios-por-id?id=${id}`),
    obterPorUf: (uf) => baseAPI.get(`${router}/obter-municipios-por-uf?uf=${uf}`)


}